import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Variant } from '../../types'
import ActionTypes from './actionTypes'

type FetchVariantsRequest = {
    type: typeof ActionTypes.VARIANTS_FETCH_REQUEST;
    payload: never;
}

type FetchVariantsFailure = {
    type: typeof ActionTypes.VARIANTS_FETCH_FAILURE;
    payload: Error;
}

type FetchVariantsSuccess = {
    type: typeof ActionTypes.VARIANTS_FETCH_SUCCESS;
    payload: Variant[];
}

function fetchVariants() {
    return createAction<RootState, Variant[], never>({
        endpoint: `${HUBBLE_API_TOKEN}/ticket-variants`,
        method: 'GET',
        types: [
            ActionTypes.VARIANTS_FETCH_REQUEST,
            ActionTypes.VARIANTS_FETCH_SUCCESS,
            ActionTypes.VARIANTS_FETCH_FAILURE,
        ],
    })
}

export type FetchVariantsAction = FetchVariantsRequest
    | FetchVariantsFailure
    | FetchVariantsSuccess

export default fetchVariants
